




























































































































































import {
  LoadingStatusType,
  ParamsReloadType,
  PndType,
  PP30FormTableViewStatusType,
  RouterAction,
  TransactionTableViewStatusType,
  WhtCertificateTableViewStatusType,
  Package,
} from "@/enums/enums";
import { MerchantId, CheckMerchantPackage, CheckMerchantAFPPackage } from "@/helper/userHelper";

import { Component, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";

const StoreSetting = namespace("Setting");
const StoreLogIn = namespace("LogIn");

@Component
export default class MainNavbar extends Vue {
  private listMenu: Array<any> = [];
  private Emi = 10;
  private hideDropdown = false;
  private isConnectWithPeak = false;
  private callCheckMerchantPackage = CheckMerchantPackage([Package.Free, Package.Basic, Package.Pro, Package.AFPFree]);
  private isMerchantPackageAFP = CheckMerchantAFPPackage();

  @StoreSetting.Getter
  private getSettingConnectPeakModel!: any;

  created() {
    if (this.getSettingConnectPeakModel) {
      this.isConnectWithPeak = this.getSettingConnectPeakModel.isPeakTaxConnected;
    }
    this.listMenu = this.SetListMenu();
  }

  public SetListMenu() {
    let isLock = false;
    let lockText = "";
    if (!this.isConnectWithPeak) {
      isLock = true;
      lockText = "Connect_Peak";
    } else if (this.callCheckMerchantPackage) {
      isLock = true;
      if (this.isMerchantPackageAFP) {
        lockText = "Package_LEDGER";
      } else {
        lockText = "Package_Pro_Plus";
      }
    }
    const lislMenu = [
      {
        name: "Menu_Home",
        icon: "",
        img: require("@/assets/img/menubar/home.png"),
        link: { name: "home" },
      },
      {
        name: "Header_WithHoldingTax",
        icon: "",
        img: require("@/assets/img/menubar/wallet.png"),
        link: { name: "withholding" },
        dropdown: [
          {
            name: "Withholding_Tax",
            link: { name: "withholding" },
            option: [
              { name: "Btn_CreateWHT", bg: "bgOption", link: { name: "withholding", at: RouterAction.Create } },
              {
                name: "FetchData",
                bg: "blueDefault",
                icon: "fas fa-sync-alt",
                link: { name: "withholding", at: RouterAction.FetchData },
                lock: { value: isLock, text: lockText },
              },
              {
                name: "Table_Tap_AwaitFiling",
                link: { name: "withholding", stid: WhtCertificateTableViewStatusType.AwaitFiling },
              },
              {
                name: "Table_Tap_FiledTax",
                link: { name: "withholding", stid: WhtCertificateTableViewStatusType.FiledTax },
              },
              { name: "Menu_Overview", link: { name: "withholding", stid: WhtCertificateTableViewStatusType.All } },
            ],
          },
          {
            name: "PND_1_Form",
            link: { name: "pnd1", epti: PndType.PND1 },
            option: [
              { name: "PND_1_Form_Create", bg: "bgOption", link: { name: "pnd1Create", epti: PndType.PND1 } },
              { name: "Menu_Overview", link: { name: "pnd1", epti: PndType.PND1 } },
            ],
          },
          {
            name: "PND_2_Form",
            link: { name: "pnd2", epti: PndType.PND2 },
            option: [
              {
                name: "PND_2_Form_Create",
                bg: "bgOption",
                link: { name: "pnd2Create", epti: PndType.PND2 },
              },
              { name: "Menu_Overview", link: { name: "pnd2", epti: PndType.PND2 } },
            ],
          },
          {
            name: "PND_3_Form",
            link: { name: "pnd3", epti: PndType.PND3 },
            option: [
              {
                name: "PND_3_Form_Create",
                bg: "bgOption",
                link: { name: "pnd3Create", epti: PndType.PND3 },
              },
              { name: "Menu_Overview", link: { name: "pnd3", epti: PndType.PND3 } },
            ],
          },
          {
            name: "PND_53_Form",
            link: { name: "pnd53", epti: PndType.PND53 },
            option: [
              {
                name: "PND_53_Form_Create",
                bg: "bgOption",
                link: { name: "pnd53Create", epti: PndType.PND53 },
              },
              { name: "Menu_Overview", link: { name: "pnd53", epti: PndType.PND53 } },
            ],
          },
          {
            name: "PND_54_Form",
            link: { name: "" },
            lock: { value: true, text: "Lock_HeaderMenu" },
            hide: true,
            option: [
              { name: "PND_54_Form_Create", bg: "bgOption", link: { name: "" } },
              { name: "Table_Tap_AwaitFiling", link: { name: "" } },
              { name: "Table_Tap_FiledTax", link: { name: "" } },
              { name: "Menu_Overview", link: { name: "" } },
            ],
          },
          {
            name: "Import_Document",
            link: { name: "" },
            lock: { value: true, text: "Lock_HeaderMenu" },
            hide: true,
          },
        ],
      },
      {
        name: "VAT",
        icon: "",
        img: require("@/assets/img/menubar/document.png"),
        link: { name: "salesVATItem" },
        dropdown: [
          {
            name: "Sales_Tax_Item",
            link: { name: "salesVATItem", stid: TransactionTableViewStatusType.All },
            option: [
              {
                name: "Create_Sales_Tax_Item",
                bg: "bgOption",
                link: { name: "salesVATItem", at: RouterAction.Create, stid: TransactionTableViewStatusType.All },
              },
              {
                name: "FetchData",
                bg: "blueDefault",
                icon: "fas fa-sync-alt",
                link: {
                  name: "salesVATItem",
                  at: RouterAction.FetchData,
                  stid: TransactionTableViewStatusType.All,
                },
                lock: { value: isLock, text: lockText },
              },
              {
                name: "Table_Tap_AwaitFiling",
                link: { name: "salesVATItem", stid: TransactionTableViewStatusType.AwaitFiling },
              },
              {
                name: "Table_Tap_FiledTax",
                link: { name: "salesVATItem", stid: TransactionTableViewStatusType.FiledTax },
              },
              { name: "Menu_Overview", link: { name: "salesVATItem", stid: TransactionTableViewStatusType.All } },
            ],
          },
          {
            name: "Purchase_Tax_Item",
            link: { name: "purchaseVATItem", stid: TransactionTableViewStatusType.All },
            option: [
              {
                name: "Create_Purchase_Tax_Item",
                bg: "bgOption",
                link: { name: "purchaseVATItem", stid: TransactionTableViewStatusType.All, at: RouterAction.Create },
              },
              {
                name: "FetchData",
                bg: "blueDefault",
                icon: "fas fa-sync-alt",
                link: {
                  name: "purchaseVATItem",
                  at: RouterAction.FetchData,
                  stid: TransactionTableViewStatusType.All,
                },
                lock: { value: isLock, text: lockText },
              },
              {
                name: "Table_Tap_AwaitFiling",
                link: { name: "purchaseVATItem", stid: TransactionTableViewStatusType.AwaitFiling },
              },
              {
                name: "Table_Tap_FiledTax",
                link: { name: "purchaseVATItem", stid: TransactionTableViewStatusType.FiledTax },
              },
              { name: "Menu_Overview", link: { name: "purchaseVATItem", stid: TransactionTableViewStatusType.All } },
            ],
          },
          {
            name: "PP30_No_Form",
            link: { name: "pp30form", stid: PP30FormTableViewStatusType.All },
            option: [
              { name: "Home_Create_PP30_Form", bg: "bgOption", link: { name: "pp30Create" } },
              { name: "Menu_Overview", link: { name: "pp30form", stid: PP30FormTableViewStatusType.All } },
            ],
          },
          {
            name: "Import_Document",
            link: { name: "" },
            lock: { value: true, text: "Lock_HeaderMenu" },
            hide: true,
          },
        ],
      },
      {
        name: "Menu_Foreign_Tax",
        icon: "",
        img: require("@/assets/img/menubar/foreigner.png"),
        link: { name: "foreigner" },
        lock: { value: true, text: "Lock_HeaderMenu" },
      },
      {
        name: "Contact",
        icon: "",
        img: require("@/assets/img/menubar/user.png"),
        link: { name: "contact" },
        canNotAccess: !this.$can("access", "Contact_Menu"),
        dropdown: [
          {
            name: "Menu_Overview",
            link: { name: "contact" },
          },
          {
            name: "Add_New_Contact",
            bg: "bgSelect",
            link: { name: "contact", at: RouterAction.Create },
            canNotAccess: !this.$can("create", "Add_Contact"),
          },
        ],
      },
      {
        name: "Menu_Setting",
        icon: "",
        img: require("@/assets/img/menubar/setting.png"),
        link: { name: "settingMerchant" },
        class: "menu-margin",
        dropdown: [
          {
            name: "Organization_Setting",
            link: { name: "settingMerchant" },
            canNotAccess: !this.$can("access", "Advance_Setting"),
          },
          {
            name: "Logo_And_Stamp",
            link: { name: "settingLogoStamp" },
            canNotAccess: !this.$can("access", "Advance_Setting"),
          },
          {
            name: "Connect_With_PEAK",
            link: { name: "settingConnectPeak" },
            canNotAccess: !this.$can("access", "Advance_Setting"),
          },
          {
            name: "Menu_UserSetting",
            link: { name: "settingUser" },
            canNotAccess: !this.$can("access", "User_Setting_Menu"),
          },
        ],
      },
    ];
    return lislMenu;
  }

  public checkActiveMenu(linkName: any) {
    if (linkName && this.$route.matched.length > 0) {
      if (linkName.name == this.$route.matched[0].name) {
        return true;
      } else {
        return false;
      }
    }
  }

  public SetQueryURL(option: any) {
    const query: any = {
      emi: MerchantId().PeakEncryption(),
      reload: ParamsReloadType.Reload,
    };

    if (option.link && option.link.stid) {
      query.stid = option.link.stid;
    }

    if (option.link && option.link.at) {
      query.at = option.link.at;
    }
    if (option.link && option.link.epti) {
      query.epti = option.link.epti.PeakEncryption();
    }

    return query;
  }
  public hide() {
    this.hideDropdown = true;
    setTimeout(() => {
      this.hideDropdown = false;
    }, 500);
  }
}
